import React from 'react'
import HighLightsBG from "../../../../assets/images/highlights-bg.png"
import Shape12 from "../../../../assets/images/shape-12.png"
import Shape21 from "../../../../assets/images/shape-22.png"

const CourseFeatures = () => {
    return (
        <div>
            <section className="highlights-style-two">
                <div className="bg-layer" ></div>
                <div className="shape">
                    <div className="shape-2 float-bob-x" style={{ backgroundImage: `url(${Shape12})` }}></div>
                </div>
                <div className="auto-container">
                    <div className="sec-title light">
                        <h2>Theory Tests Made Easy</h2>
                        <p>
                        Are you ready to take your theory test and become a confident, skilled driver? We’ve partnered with Driving Test Success, the leading theory test revision app used by over 12 million learners, to help you prepare for your theory test. Just £7.50 for three months full access.
                        </p>
                    </div>
                    <div className="row clearfix">
                        <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                            <div className="single-item wow fadeInLeft animated animated" data-wow-delay="00ms" data-wow-duration="1500ms" >
                                <div className="inner">
                                    <ul className="icon-list">
                                        <li><i className="bi bi-book"></i></li>
                                        <li><i className=""></i></li>
                                    </ul>
                                    <h4><a href="#">Study On The Go</a></h4>
                                    <p>Access anytime, anywhere, from any device</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                            <div className="single-item wow fadeInRight animated animated" data-wow-delay="00ms" data-wow-duration="1500ms" >
                                <div className="inner">
                                    <ul className="icon-list">
                                        <li><i className="bi bi-trophy"></i></li>
                                        <li><i className=""></i></li>
                                    </ul>
                                    <h4><a href="#">Quality Content</a></h4>
                                    <p>Access to the latest Licensed DVSA content.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                            <div className="single-item wow fadeInLeft animated animated" data-wow-delay="300ms" data-wow-duration="1500ms">
                                <div className="inner">
                                    <ul className="icon-list">
                                        <li><i className="bi bi-telephone-inbound"></i></li>
                                        <li><i className=""></i></li>
                                    </ul>
                                    <h4><a href="#">UK Support</a></h4>
                                    <p>Our UK team are with you all the way</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                            <div className="single-item wow fadeInRight animated animated" data-wow-delay="300ms" data-wow-duration="1500ms" >
                                <div className="inner">
                                    <ul className="icon-list">
                                        <li><i className="bi bi-globe-americas"></i></li>
                                        <li><i className=""></i></li>
                                    </ul>
                                    <h4><a href="#">Available for GB and NI</a></h4>
                                    <p>Wide range of study material for both GB and NI</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default CourseFeatures
